import React from 'react'
import { Column } from '../components/layout'
import styled from 'styled-components'
import { useStore } from 'effector-react'
import store from '../store'
import { title1, subbody } from '../utils/selector'

export default function Situation() {
  const state = useStore(store)

  return (
    <Container>
      <Title>根据你的回答，由于你</Title>
      {!state.livingInUS && (
        <div>
          <div>
            <b>不长期居住在美国</b>：境外优选套餐更适合你。
          </div>
          <div>
            我们会为你提供公司银行账户远程开设服务，无需你亲自赴美。公司注册需要一个较固定的美国地址收发公司相关信件。建议在之后的信息收集页面选择”租用办公地址“。
          </div>
        </div>
      )}

      {!state.haveSSN && (
        <div>
          <div>
            <b>没有美国社会安全号（SSN）</b>：境外优选套餐更适合你。
          </div>
          <div>
            我们会为你完成额外的申请流程（Form-SS4）并人工致电税务局完成公司税号注册。
          </div>
        </div>
      )}

      {state.aim && (
        <div>
          <div>
            <b>{state.aim.title}</b>：{state.aim.description}
          </div>
        </div>
      )}

      {state.livingInUS && !['DE', 'CA'].includes(state.stateOfUS) && (
        <div>
          <b>居住在「{state.stateOfUS}」州</b>
          ：我们推荐在加州或特拉华州注册公司。但是如果你想在其他州进行注册，欢迎发送邮件至
          <a className="mail" href="mailto:corplaw@ailaw.ai">
            corplaw@ailaw.ai
          </a>
          联系我们获取报价 ($600 – $900之间)。
        </div>
      )}
    </Container>
  )
}

const Container = styled.div`
  background: #edf4f7;
  color: #364d6e;
  padding: 40px;
  border-radius: 24px;
  max-width: 918px;

  .mail {
    color: inherit;
    margin: 0 4px;
  }

  > * + * {
    margin-top: 8px;
  }
`

const Title = styled.p`
  ${title1}
  text-align: center;
`
